import { useRegister } from '../hooks/useRegister'
import { RestrictionConfig } from '../hooks/useRestrictions.constate'

export function RestrictionsRegister(
  registerProps: Omit<RestrictionConfig, 'path'>
) {
  const { Element, props } = registerProps

  useRegister({
    Element,
    props,
  })

  return null
}
